<template>
  <div>
    <va-aside-layout :title="asideTitle">
      <base-material-card>
        <template v-slot:heading>
          <div class="display-2">
            {{ titleForm }}
          </div>
        </template>
        <path-form :id="id" :item="item" @saved="onSaved"></path-form>
      </base-material-card>
    </va-aside-layout>
    <base-material-card :icon="resource.icon" :title="title">
      <va-list
        ref="list"
        :filters="filters"
        disable-create-redirect
        @action="onAction"
      >
        <va-data-table
          :fields="fields"
          disable-create-redirect
          disable-edit-redirect
          @item-action="onAction"
        >
        </va-data-table>
      </va-list>
    </base-material-card>
  </div>
</template>

<script>
export default {
  props: ["resource", "title"],
  data() {
    return {
      filters: [
        "id",
        "sequence",
        { source: "route_id", type: "select" },
        { source: "pointIni_id", type: "select" },
        { source: "action_id", type: "select" }
      ],
      fields: [
        { source: "id", sortable: true },
        { source: "sequence", sortable: true },
        { source: "route_id", type: "select", sortable: true },
        { source: "pointIni_id", type: "select", sortable: true },
        { source: "action_id", type: "select", sortable: true }
      ],
      asideTitle: null,
      titleForm: null,
      id: null,
      item: null,
      show: false
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onAction({ title, id, item }) {
      this.asideTitle = " ";
      this.titleForm = title;
      this.id = id;
     
      if (item != null) {
        this.item = item != null ? item : item;
      }
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    }
  }
};
</script>
